// Filtro e ordinamento prezzo lato client per i market con valuta diversa da quella dello shop.
// In quei market Shopify non espone il filtro price_range, ignora filter.v.price.* e ordina
// per prezzo nella valuta dello shop, quindi: carichiamo l'indice della collezione (sezione
// collection-price-index, con gli altri filtri gia' applicati da Shopify) e filtriamo/ordiniamo
// noi con i prezzi del market.
(() => {
  const PARAM_MIN = 'filter.v.price.gte';
  const PARAM_MAX = 'filter.v.price.lte';
  const PARAM_SORT = 'sort_by';
  const PRICE_SORTS = ['price-ascending', 'price-descending'];
  const INDEX_SECTION = 'collection-price-index';
  const MAX_INDEX_PAGES = 8;

  const cache = new Map();
  let runId = 0;

  const getConfig = () => document.querySelector('[data-client-price-filter]');

  // "1.234,50" / "1,234.50" / "150" -> centesimi
  const toCents = (raw) => {
    if (raw == null) return null;
    let value = String(raw).replace(/[^\d.,]/g, '');
    if (!value) return null;
    const lastSep = Math.max(value.lastIndexOf(','), value.lastIndexOf('.'));
    if (lastSep > -1 && value.length - lastSep - 1 <= 2) {
      value = value.slice(0, lastSep).replace(/[.,]/g, '') + '.' + value.slice(lastSep + 1);
    } else {
      value = value.replace(/[.,]/g, '');
    }
    const number = parseFloat(value);
    return Number.isNaN(number) ? null : Math.round(number * 100);
  };

  const getRange = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      rawMin: params.get(PARAM_MIN) || '',
      rawMax: params.get(PARAM_MAX) || '',
      min: toCents(params.get(PARAM_MIN)),
      max: toCents(params.get(PARAM_MAX)),
    };
  };

  const getPriceSort = () => {
    const sort = new URLSearchParams(window.location.search).get(PARAM_SORT);
    return PRICE_SORTS.includes(sort) ? sort : null;
  };

  const indexUrl = (page) => {
    const params = new URLSearchParams(window.location.search);
    [PARAM_MIN, PARAM_MAX, 'page', 'section_id'].forEach((key) => params.delete(key));
    if (getPriceSort()) params.delete(PARAM_SORT);
    params.set('section_id', INDEX_SECTION);
    params.set('page', page);
    return `${window.location.pathname}?${params.toString()}`;
  };

  const fetchIndexPage = async (page) => {
    const url = indexUrl(page);
    if (!cache.has(url)) {
      cache.set(
        url,
        fetch(url, { credentials: 'same-origin' })
          .then((response) => response.text())
          .then((html) => new DOMParser().parseFromString(html, 'text/html').getElementById('PriceIndex'))
          .catch((error) => {
            cache.delete(url);
            throw error;
          })
      );
    }
    return cache.get(url);
  };

  const fetchIndex = async () => {
    const first = await fetchIndexPage(1);
    if (!first) return { items: [], countTemplate: '' };

    const pages = Math.min(parseInt(first.dataset.pages || '1', 10), MAX_INDEX_PAGES);
    const rest = await Promise.all(Array.from({ length: pages - 1 }, (_, i) => fetchIndexPage(i + 2)));

    const items = [first, ...rest]
      .filter(Boolean)
      .flatMap((index) => Array.from(index.querySelectorAll(':scope > ul > li')));

    return { items, countTemplate: first.dataset.countTemplate };
  };

  const syncInputs = ({ rawMin, rawMax }) => {
    const config = getConfig();
    if (!config) return;
    config.querySelectorAll('input').forEach((input) => {
      if (input === document.activeElement) return;
      input.value = input.name === PARAM_MIN ? rawMin : rawMax;
    });
  };

  const formatRangeLabel = ({ rawMin, rawMax }) => {
    const symbol = getConfig()?.dataset.currencySymbol || '';
    return `${symbol}${rawMin || 0} - ${rawMax ? symbol + rawMax : '∞'}`;
  };

  const renderPill = (range) => {
    const pills = document.querySelector('#FacetFiltersPillsForm .active-facets');
    if (!pills) return;
    pills.querySelector('[data-client-price-pill]')?.remove();

    const params = new URLSearchParams(window.location.search);
    [PARAM_MIN, PARAM_MAX, 'page'].forEach((key) => params.delete(key));
    const query = params.toString();

    const pill = document.createElement('facet-remove');
    pill.setAttribute('data-client-price-pill', '');
    pill.innerHTML = `
      <a href="${window.location.pathname}${query ? '?' + query : ''}" class="active-facets__button active-facets__button--light">
        <span class="active-facets__button-inner button-filter items-center justify-center rounded-none text-[12px] gap-2 flex">
          <svg width="20" height="20" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 22.5068L22.5 7.50684M7.5 7.50684L22.5 22.5068" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </a>`;
    pill.querySelector('span').append(formatRangeLabel(range));

    const clearAll = pills.querySelector('.active-facets__button-wrapper');
    clearAll ? pills.insertBefore(pill, clearAll) : pills.appendChild(pill);
  };

  const renderGrid = (grid, items, perPage, countTemplate) => {
    const container = grid.closest('.collection') || grid.parentElement;
    const counter = container.querySelector('.js-products-count');
    container.querySelector('collection-load-more')?.classList.add('hidden');
    container.querySelector('[data-client-price-more]')?.remove();

    if (counter && countTemplate) {
      counter.dataset.template = countTemplate.replace('__TOTAL__', items.length);
    }

    let shown = 0;
    const showNext = () => {
      items.slice(shown, shown + perPage).forEach((item) => grid.appendChild(item));
      shown = Math.min(shown + perPage, items.length);

      window.updatePLPProductsCount?.();
      document.dispatchEvent(new CustomEvent('swiper:reinitialize'));
      document.dispatchEvent(new CustomEvent('swatchplp:reinitialize'));
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));

      if (shown >= items.length) container.querySelector('[data-client-price-more]')?.remove();
    };

    grid.innerHTML = '';
    showNext();

    if (items.length > shown) {
      const wrapper = document.createElement('div');
      wrapper.className = 'flex justify-center mt-2';
      wrapper.setAttribute('data-client-price-more', '');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button-line';
      button.textContent = getConfig()?.dataset.loadMoreLabel || 'Load more';
      button.addEventListener('click', showNext);
      wrapper.appendChild(button);
      (counter || grid).after(wrapper);
    }
  };

  const apply = async () => {
    const config = getConfig();
    if (!config) return;

    const range = getRange();
    const hasRange = range.min != null || range.max != null;
    const priceSort = getPriceSort();
    syncInputs(range);
    if (!hasRange && !priceSort) return;

    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const currentRun = ++runId;
    const loadingTarget = grid.closest('.collection');
    loadingTarget?.classList.add('loading');

    try {
      const { items, countTemplate } = await fetchIndex();
      if (currentRun !== runId) return;

      const min = range.min ?? 0;
      const max = range.max ?? Infinity;
      const matches = items
        .filter((item) => {
          const priceMin = Number(item.dataset.priceMin);
          const priceMax = Number(item.dataset.priceMax);
          return priceMax >= min && priceMin <= max;
        })
        .map((item) => document.importNode(item, true));

      if (priceSort) {
        const direction = priceSort === 'price-ascending' ? 1 : -1;
        matches.sort((a, b) => (Number(a.dataset.priceMin) - Number(b.dataset.priceMin)) * direction);
      }

      const liveGrid = document.getElementById('product-grid');
      if (!liveGrid) return;
      renderGrid(liveGrid, matches, parseInt(config.dataset.perPage || '36', 10), countTemplate);
      if (hasRange) renderPill(range);
    } catch (error) {
      console.error('[price filter]', error);
    } finally {
      if (currentRun === runId) document.querySelector('#ProductGridContainer .collection')?.classList.remove('loading');
    }
  };

  window.clientPriceFilter = { apply };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
